var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7.25C13.2386 7.25 11 9.48857 11 12.25C11 15.0114 13.2386 17.25 16 17.25C18.7614 17.25 21 15.0114 21 12.25C21 9.48857 18.7614 7.25 16 7.25Z",
    stroke: "#333333",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49246 20.5651C11.3549 19.2606 13.5936 18.5 16 18.5C18.4064 18.5 20.6451 19.2606 22.5075 20.5651C22.9779 20.8945 23.289 21.3288 23.4242 21.8175C23.5585 22.303 23.5078 22.8008 23.3235 23.2381C22.9561 24.1102 22.0628 24.75 20.9556 24.75H11.0444C9.93718 24.75 9.04389 24.1102 8.6765 23.2381C8.49224 22.8008 8.44144 22.303 8.5758 21.8175C8.71104 21.3288 9.02214 20.8945 9.49246 20.5651Z",
    stroke: "#333333",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.a8447f36cddcb76486b3b058b8822f09.svg";
export { ForwardRef as ReactComponent };